import React, { useEffect, useState } from 'react'
import createAirlineCommission from '../../../../controllers/settings/AirlineCommission/createAirlineCommission';
import { enqueueSnackbar } from 'notistack';
import AirlinesInput from '../../../../components/form/AirlinesInput';
import TextInput from '../../../../components/form/TextInput';
import Button1 from '../../../../components/form/Button1';
import updateAirlineCommission from '../../../../controllers/settings/AirlineCommission/updateAirlineCommission';
import CitiesInput from '../../../../components/form/CitiesInput';
import Icon from '../../../../components/HOC/Icon';
import { Autocomplete, MenuItem, TextField } from '@mui/material';
import { cabinClassData } from '../../../../data/flight/bookingConstants';


const initData = {
    airline: '',
    name: '',
    commission: null,
    "includedOrigins": [],
    "excludedOrigins": [],
    "includedDestinations": [],
    "excludedDestinations": [],
    "includedFareBasis": [
        // "AW5EDTS"
    ],
    "includedBookingClasses": [
        // "Y"
    ],
    "excludedBookingClasses": [],
    "includedCabinClasses": [
        // "Economy"
        // PremiumEconomy
        // Business
        // FirstClass
    ],
    "excludedCabinClasses": [],
    "flightRoute": "All" //Oneway, RoundTrip, MultiCity
}

export default function AirlineCommissionForm({data:defData,callback,close}) {
       const [data,setData] = useState(initData)
        const [loadings,setLoadings] = useState({submit: false})
    
        useEffect(() => {
            setData({...initData,...(defData||{})})
        },[defData,close])

        console.log(data,' < == ')
            
        async function handleSubmit(ev) {
            ev?.preventDefault();
    
            const payload = {...data,
                commission: Number(data?.commission)
            }
            
            setLoadings({...loadings,submit: true})
            let res = {return: false, msg: 'Something went wrong on our end! 0XACF'};

            if(!defData)
                res = await createAirlineCommission(payload);
            else 
                res = await updateAirlineCommission(defData?._id,payload)
            setLoadings({...loadings,submit: false})
            if(res?.return) {
                enqueueSnackbar(res?.msg,{variant: 'success'})
                callback && callback()
                close && close();
            } else enqueueSnackbar(res?.msg,{variant: 'error'})
        }
    
  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-4 p-10 min-w-[400px]'>
        <div className='flex flex-wrap sm:flex-nowrap gap-4'>
            <AirlinesInput val={data?.airline} returnData={(val) => val?.id || val ? setData({...data,airline: val?.id || val}) : null } />
            <TextInput label='Name' value={data?.name} onChange={(ev) => setData({...data,name: ev?.target?.value})} />
        </div>
        <TextInput label='Commission' type='number'
            value={data?.commission} onChange={(ev) => setData({...data,commission: Number(ev.target.value)})} />
            
        <TextInput select label='Flight Route'>
            <MenuItem value='All' >All</MenuItem>
            <MenuItem value='Oneway' >One Way</MenuItem>
            <MenuItem value='RoundTrip' >Round Trip</MenuItem>
            <MenuItem value='MultiCity' >Multi City</MenuItem>
        </TextInput>

        <div className='flex gap-4 sm:min-w-[600px]'>
            <MultipleSelector 
                label={'Origins Included'}
                data={data?.includedOrigins || []}
                // setData={(val) =>
                //     setData({...data,includedOrigins: val})
                // }
                handleRemove={(iata) => 
                    setData({...data, handleRemove: data?.handleRemove?.filter(val => val !== iata)})
                }
                inputRender={({value,setValue}) => (
                    <CitiesInput
                        label={""}
                        size="small"
                        placeholder="e.g LOS"
                        value={value}
                        onChange={(val) => {
                            if(val?.iata)
                                setData({...data,includedOrigins: [...(data?.includedOrigins || []), val?.iata]})
                            setValue(val)
                        }}
                    />
                )}
            />
            <MultipleSelector 
                label={'Origins Excluded'}
                data={data?.excludedOrigins || []}
                handleRemove={(iata) => 
                    setData({...data, excludedOrigins: data?.excludedOrigins?.filter(val => val !== iata)})
                }
                inputRender={({value,setValue}) => (
                    <CitiesInput
                        label={""}
                        size="small"
                        placeholder="e.g LOS"
                        value={value}
                        onChange={(val) => {
                            if(val?.iata)
                                setData({...data,excludedOrigins: [...(data?.excludedOrigins || []), val?.iata]})
                            setValue(val)
                        }}
                    />
                )}
            />
        </div>
        <div className='flex gap-4 sm:min-w-[600px]'>
            <MultipleSelector 
                label={'Desinations Included'}
                data={data?.includedDestinations || []}
                handleRemove={(iata) => 
                    setData({...data, includedDestinations: data?.includedDestinations?.filter(val => val !== iata)})
                }
                inputRender={({value,setValue}) => (
                    <CitiesInput
                        label={""}
                        size="small"
                        placeholder="e.g LOS"
                        value={value}
                        onChange={(val) => {
                            if(val?.iata)
                                setData({...data,includedDestinations: [...(data?.includedDestinations || []), val?.iata]})
                            setValue(val)
                        }}
                    />
                )}
            />
            <MultipleSelector 
                label={'Destinations Excluded'}
                data={data?.excludedDestinations || []}
                handleRemove={(iata) => 
                    setData({...data, excludedDestinations: data?.excludedDestinations?.filter(val => val !== iata)})
                }
                inputRender={({value,setValue}) => (
                    <CitiesInput
                        label={""}
                        size="small"
                        placeholder="e.g LOS"
                        value={value}
                        onChange={(val) => {
                            if(val?.iata)
                                setData({...data,excludedDestinations: [...(data?.excludedDestinations || []), val?.iata]})
                            setValue(val)
                        }}
                    />
                )}
            />
        </div>
        <MultipleSelector 
            label={'Included Fare Basis'}
            data={data?.includedFareBasis || []}
            handleRemove={(iata) => 
                setData({...data, includedFareBasis: data?.includedFareBasis?.filter(val => val !== iata)})
            }
            inputRender={({value,setValue}) => (
                <Autocomplete label={""} size="small" options={[]}
                    value={value}
                    onChange={(ev,val) => {
                        if(val?.inputValue)
                            setData({...data,includedFareBasis: [...(data?.includedFareBasis || []), val?.inputValue]})
                        setValue(null)
                    }}
                    filterOptions={(options, params) => {
                        const filtered = [...options]

                        const { inputValue } = params;
                        // Suggest the creation of a new value
                        const isExisting = options.some((option) => inputValue === option.title);
                        if (inputValue !== '' && !isExisting) {
                        filtered.push({
                            inputValue,
                            title: `Add "${inputValue}"`,
                        });
                        }

                        return filtered;
                    }}
                    renderInput={(params) => (
                        <TextField {...params} />
                    )}
                    renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                            <li key={key} {...optionProps}>
                                {option?.title}
                            </li>
                        );
                    }}
                    getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === 'string') {
                            return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        // Regular option
                        return option.title;
                    }}
                    clearOnBlur
                    blurOnSelect

                />
            )}
        />
        <div className='flex gap-4 sm:min-w-[600px]'>
            <MultipleSelector 
                label={'Included Booking Classes'}
                data={data?.includedBookingClasses || []}
                handleRemove={(iata) => 
                    setData({...data, includedBookingClasses: data?.includedBookingClasses?.filter(val => val !== iata)})
                }
                inputRender={({value,setValue}) => (
                    <Autocomplete label={""} size="small" options={[...Array(26)].map((_, i) => String.fromCharCode(65 + i))}
                        value={value} selectOnFocus 
                        onChange={(ev,val) => {
                            setValue(null)
                            setData({...data,includedBookingClasses: [...(data?.includedBookingClasses || []), val]})
                        }}
                        // filterOptions={(options, params) => {
                        //     const filtered = [...options]

                        //     const { inputValue } = params;
                        //     // Suggest the creation of a new value
                        //     const isExisting = options.some((option) => inputValue === option.title);
                        //     if (inputValue !== '' && !isExisting) {
                        //     filtered.push({
                        //         inputValue,
                        //         title: `Add "${inputValue}"`,
                        //     });
                        //     }

                        //     return filtered;
                        // }}
                        renderInput={(params) => (
                            <TextField {...params} />
                        )}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                                <li key={key} {...optionProps}>
                                    {option}
                                </li>
                            );
                        }}
                        getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                                return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                                return option.inputValue;
                            }
                            // Regular option
                            return option.title;
                        }}
                        clearOnBlur
                        blurOnSelect

                    />
                )}
            />
            <MultipleSelector 
                label={'Excluded Booking Classes'}
                data={data?.excludedBookingClasses || []}
                handleRemove={(iata) => 
                    setData({...data, excludedBookingClasses: data?.excludedBookingClasses?.filter(val => val !== iata)})
                }
                inputRender={({value,setValue}) => (
                    <Autocomplete label={""} size="small" options={[...Array(26)].map((_, i) => String.fromCharCode(65 + i))}
                        value={value} selectOnFocus 
                        onChange={(ev,val) => {
                            setValue(null)
                            setData({...data,excludedBookingClasses: [...(data?.excludedBookingClasses || []), val]})
                        }}
                        // filterOptions={(options, params) => {
                        //     const filtered = [...options]

                        //     const { inputValue } = params;
                        //     // Suggest the creation of a new value
                        //     const isExisting = options.some((option) => inputValue === option.title);
                        //     if (inputValue !== '' && !isExisting) {
                        //     filtered.push({
                        //         inputValue,
                        //         title: `Add "${inputValue}"`,
                        //     });
                        //     }

                        //     return filtered;
                        // }}
                        renderInput={(params) => (
                            <TextField {...params} />
                        )}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                                <li key={key} {...optionProps}>
                                    {option}
                                </li>
                            );
                        }}
                        getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                                return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                                return option.inputValue;
                            }
                            // Regular option
                            return option.title;
                        }}
                        clearOnBlur
                        blurOnSelect

                    />
                )}
            />
        </div>
        <div className='flex gap-4 sm:min-w-[600px]'>
            <MultipleSelector 
                label={'Included Cabin Classes'}
                data={data?.includedCabinClasses || []}
                handleRemove={(iata) => 
                    setData({...data, includedCabinClasses: data?.includedCabinClasses?.filter(val => val !== iata)})
                }
                inputRender={({value,setValue}) => (
                    <Autocomplete label={""} size="small" options={['Economy','PremiumEconomy','Business','FirstClass']}
                        value={value} selectOnFocus 
                        onChange={(ev,val) => {
                            setValue(null)
                            setData({...data,includedCabinClasses: [...(data?.includedCabinClasses || []), val]})
                        }}
                        // filterOptions={(options, params) => {
                        //     const filtered = [...options]

                        //     const { inputValue } = params;
                        //     // Suggest the creation of a new value
                        //     const isExisting = options.some((option) => inputValue === option.title);
                        //     if (inputValue !== '' && !isExisting) {
                        //     filtered.push({
                        //         inputValue,
                        //         title: `Add "${inputValue}"`,
                        //     });
                        //     }

                        //     return filtered;
                        // }}
                        renderInput={(params) => (
                            <TextField {...params} />
                        )}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                                <li key={key} {...optionProps}>
                                    {option}
                                </li>
                            );
                        }}
                        getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                                return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                                return option.inputValue;
                            }
                            // Regular option
                            return option.title;
                        }}
                        clearOnBlur
                        blurOnSelect

                    />
                )}
            />
            <MultipleSelector 
                label={'Excluded Cabin Classes'}
                data={data?.excludedCabinClasses || []}
                handleRemove={(iata) => 
                    setData({...data, excludedCabinClasses: data?.excludedCabinClasses?.filter(val => val !== iata)})
                }
                inputRender={({value,setValue}) => (
                    <Autocomplete label={""} size="small" options={cabinClassData?.map(obj => obj?.value)}
                        value={value} selectOnFocus 
                        onChange={(ev,val) => {
                            setValue(null)
                            setData({...data,excludedCabinClasses: [...(data?.excludedCabinClasses || []), val]})
                        }}
                        // filterOptions={(options, params) => {
                        //     const filtered = [...options]

                        //     const { inputValue } = params;
                        //     // Suggest the creation of a new value
                        //     const isExisting = options.some((option) => inputValue === option.title);
                        //     if (inputValue !== '' && !isExisting) {
                        //     filtered.push({
                        //         inputValue,
                        //         title: `Add "${inputValue}"`,
                        //     });
                        //     }

                        //     return filtered;
                        // }}
                        renderInput={(params) => (
                            <TextField {...params} />
                        )}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                                <li key={key} {...optionProps}>
                                    {option}
                                </li>
                            );
                        }}
                        getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                                return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                                return option.inputValue;
                            }
                            // Regular option
                            return option.title;
                        }}
                        clearOnBlur
                        blurOnSelect

                    />
                )}
            />
        </div>
        <div className='flex gap-4 items-center'>
            {close ? 
                <div>
                    <Button1 variant='outlined' type='button' onClick={() => close(false)}>Close</Button1>
                </div>
            :null}
            <Button1 type='submit' loading={loadings?.submit}>{!defData?'Add':'Update'}</Button1>
        </div>
    </form>
  )
}


function MultipleSelector({label,data,handleRemove,inputRender}) {
  const [value,setValue] = useState("");

  const Tag = ({value}) => (
    <div className="flex items-center border rounded-full text-sm border-primary/30">
      <span className="px-2 py-[2px]">
        {value || ""}
      </span>
      <span className="hover:text-red-400 flex-1 py-[2px] rounded-r-full cursor-pointer pr-2 inline-block h-full"
       onClick={() => handleRemove(value)} 
      >
        <Icon icon='mdi:close' className='!w-4 !h-4' />
      </span>
    </div>
  )

  return (
    <div className="flex flex-col flex-1">
      <small>{label}</small>
      <div className="flex gap-2 items-center max-w-[500px] overflow-x-auto pb-1 my-2">
        {(data)?.map((val,i) => 
          <Tag value={val} key={i} />
        )}
      </div>
      <div>
        {inputRender && inputRender({value,setValue})}
      </div>
    </div>
  )
}